import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Box,
  LinearProgress
} from '@mui/material';
import { School, Code, PlaylistAddCheck, TrendingUp } from '@mui/icons-material';
import StatCard from '../../StatCard';

function TeacherOverviewTab({ overviewStats, loading }) {
  if (loading) {
    return (
      <Container maxWidth="xl">
        <Typography component="h2" variant="h6" sx={{ mb: 3 }}>
          概览
        </Typography>
        <LinearProgress />
      </Container>
    );
  }

  if (!overviewStats) {
    return (
      <Container maxWidth="xl">
        <Typography component="h2" variant="h6" sx={{ mb: 3 }}>
          概览
        </Typography>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="body1" color="text.secondary">
            暂无数据，请选择课程后查看统计信息
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Typography component="h2" variant="h6" sx={{ mb: 3 }}>
        概览
      </Typography>

      {/* Stats Cards */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <StatCard
            title="总学生数"
            value={String(overviewStats?.totalStudents || 0)}
            interval="注册学生总数"
            icon={School}
            color="#667eea"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <StatCard
            title="总题目数"
            value={String(overviewStats?.totalQuestions || 0)}
            interval="题库题目总数"
            icon={Code}
            color="#f093fb"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <StatCard
            title="总提交数"
            value={String(overviewStats?.totalSubmissions || 0)}
            interval="学生提交总数"
            icon={PlaylistAddCheck}
            color="#4facfe"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <StatCard
            title="平均活跃度"
            value={String(overviewStats?.totalStudents > 0
              ? Math.round(overviewStats.totalSubmissions / overviewStats.totalStudents)
              : 0)}
            interval="提交/人"
            icon={TrendingUp}
            color="#fa709a"
          />
        </Grid>
      </Grid>

      {/* Category Stats */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        各专题统计
      </Typography>
      <Card variant="outlined">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>专题</strong></TableCell>
                <TableCell align="center"><strong>题目数</strong></TableCell>
                <TableCell align="center"><strong>提交数</strong></TableCell>
                <TableCell align="center"><strong>平均分</strong></TableCell>
                <TableCell align="center"><strong>通过率</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {overviewStats?.categoryStats?.map((cat) => (
                <TableRow key={cat.category} hover>
                  <TableCell>
                    <Chip label={cat.category} color="primary" variant="outlined" />
                  </TableCell>
                  <TableCell align="center">{cat.totalQuestions}</TableCell>
                  <TableCell align="center">{cat.totalSubmissions}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={`${cat.averageScore}分`}
                      color={cat.averageScore >= 80 ? 'success' : cat.averageScore >= 60 ? 'warning' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <LinearProgress
                        variant="determinate"
                        value={cat.passRate}
                        sx={{ flexGrow: 1, height: 6, borderRadius: 3 }}
                        color={cat.passRate >= 80 ? 'success' : cat.passRate >= 60 ? 'warning' : 'inherit'}
                      />
                      <Typography variant="body2" sx={{ minWidth: 40 }}>
                        {cat.passRate}%
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
              {(!overviewStats?.categoryStats || overviewStats.categoryStats.length === 0) && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography color="text.secondary" py={2}>暂无数据</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Container>
  );
}

export default TeacherOverviewTab;
